// extracted by css-extract-rspack-plugin
export default {"content":"Y1QD0","dragContainer":"kEzZr","dragHandle":"qx2IP","wrapper":"IvjhT"};